export class SliderService {
  constructor($http) {
    this.http = $http;
  }

  getPhotos() {
    return this.http.get("/api/slider/photos");
  }
}
